// extracted by mini-css-extract-plugin
export default {"aboutUs":"FrameComponent1_aboutUs__cky1W","divtrackSeparator":"FrameComponent1_divtrackSeparator__jhlaW","aboutUsParent":"FrameComponent1_aboutUsParent__CbPUA"};